module.exports = __webpack_public_path__ + "static/img/research.fc9d86d6.png";